<template>

  <section class="pt-0" v-if="$root.instance">

    <div>

      <div v-if="extras.length == 0">
        <h3>There are no extras available for this tour.</h3>
      </div>

      <table class="table">
        <thead>
          <th>Extra</th>
          <th>Price</th>
          <th>Quantity</th>
          <th>Total Amount</th>
          <th></th>
        </thead>

        <tbody>
          <tr v-for="extra in extras" :key="extra.name">
              <td>
                {{ extra.name }}
                &nbsp;
                <span v-if="extra.short_description" v-on:click="showExtraDescription(extra.name, extra.short_description)" style="curposr:pointer" title="About Extra">
                  <svg height="20" viewBox="0 0 48 48" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h48v48h-48z" fill="none"/>
                    <path d="M22 34h4v-12h-4v12zm2-30c-11.05 0-20 8.95-20 20s8.95 20 20 20 20-8.95 20-20-8.95-20-20-20zm0 36c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm-2-22h4v-4h-4v4z"/>
                  </svg>
                </span>
              </td>
              <td>&pound;{{ extra.price }}</td>
              <td>{{ countExtras(extra.id) }}</td>
              <td>&pound;{{ countExtras(extra.id, 'qty_total') }}</td>
              <td>
                <div style="display: flex;">
                  <template v-if="extra.canAdd">
                    <button class="btn btn-sm btn-primary" v-on:click="addExtra(extra.id, extra.name, extra.price,$root.tour.id, extra.for_per_person)">+</button>
                  </template>
                  <template v-else>
                    <button class="btn btn-sm btn-primary" disabled>+</button>
                  </template>
                  &nbsp;
                  <button class="btn btn-sm btn-primary" v-on:click="removeExtra(extra.id)">-</button>

                </div>
              </td>
          </tr>
        </tbody>

      </table>

    </div>



    <br><br>

    <button type="submit" class="btn btn-primary" v-on:click="proceed">Next</button>
  
    <modal v-show="showDescModal" @close="hideExtraModal">
      <template slot="header">
        {{ selectedExtraTitle }}
      </template>
      <template slot="body">
        <p>{{ selectedExtraDescription }}</p>
      </template>
    </modal>
  
  </section>
  
</template>

<script>

import axios from 'axios';
import Modal from './Modal.vue'

export default {
  name: 'Extras',
  components:{
    Modal
  },
  data () {
    return {
      extras: [],
      chosenExtras: [],
      showDescModal: false,
      selectedExtraTitle:null,
      selectedExtraDescription:null
    }
  },
  methods: {
    getExtras()
    {
      this.loading = true

      let tourAirLines = [];

      if (this.$root.booking.tour_bookings) {
        this.$root.booking.tour_bookings.forEach((element) => {
          if(element.instance.flights && element.instance.flights.length > 0 ){
            element.instance.flights.forEach((flight) => {
              tourAirLines.push(flight.airline)
            })
          }
        })
      }


      axios.post(this.$root.$api + 'extras/tourextras', {
        tour_id: this.$root.tour.id,
        departure_date: this.$root.instance.departure_date,
        return_date: this.$root.instance.departure_date,
        airlines:[...new Set(tourAirLines)]
      })
        .then((response) => {
        this.loading = false
        let foundExtras = response.data.data
        
        // console.log(this.extras)
        if(foundExtras == 0)
        {
          this.proceed();
        }else {
          foundExtras.forEach((element) => {
            element.canAdd = true
            element.canSub = true
          })

          this.extras = foundExtras

        }
        

      },(error) => {
        console.log(error);
      });

    },
    addExtra(extra, name, price, tour_id,for_per_person)
    {
      
      var foundExtra = this.chosenExtras.find(x=> x.extra_id === extra)

      if(foundExtra){
        foundExtra.quantity = foundExtra.quantity + 1
        if (foundExtra.quantity>=this.$root.passengerCount) {
          let extraIndex = this.extras.findIndex(element => element.id == extra)
          if (extraIndex >= 0 ) {
            this.extras[extraIndex].canAdd = false
          }
        }
      }else
      {
        let quantity = 1;
        if(for_per_person){
          quantity = this.$root.passengerCount
          // Disable the Add button
          let extraIndex = this.extras.findIndex(element => element.id == extra)
          if (extraIndex >= 0 ) {
            this.extras[extraIndex].canAdd = false
          }

        }else {
          
        }
        var thisExtra = {extra_id: extra, extra_name: name, extra_price: price, extra_tour_id: tour_id, quantity, for_per_person}
        this.chosenExtras.push(thisExtra)
      }

      this.$root.booking.extras = this.chosenExtras
    },
    removeExtra(extra) {

      // var foundExtra = this.chosenExtras.find(x=> x.extra_id === extra)      
      var foundExtra = this.chosenExtras.find(x=> x.extra_id === extra)
      
      if(foundExtra) {
        let defaultQuantity = 1;
        if(foundExtra.for_per_person) {
          defaultQuantity = this.$root.passengerCount
          let extraIndex = this.extras.findIndex(element => element.id == extra)
          if (extraIndex >= 0 ) {
            this.extras[extraIndex].canAdd = true
          }
        }

        foundExtra.quantity = foundExtra.quantity - defaultQuantity;
        if(foundExtra.quantity <= 0){
          // foundExtra.quantity = 0
          // Remove from the array
          const updatedExtraObject = this.chosenExtras.filter(object => {
            return object.extra_id !== extra;
          });
          this.chosenExtras = updatedExtraObject
        }else{
          let extraIndex = this.extras.findIndex(element => element.id == extra)
          if (extraIndex >= 0 ) {
            this.extras[extraIndex].canAdd = true
          }

        }
      }

      this.$root.booking.extras = this.chosenExtras
    },
    countExtras(extra, count_type = 'qty')
    {
      var foundExtra = this.chosenExtras.find(x=> x.extra_id === extra)
      if (foundExtra) {
        var qty = 0
        var qtyTotal = 0
        if(count_type == 'qty'){
          qty = foundExtra.quantity
          return qty
        }else if(count_type == 'qty_total'){
          qtyTotal = parseFloat(foundExtra.quantity * Number(foundExtra.extra_price))
          return qtyTotal;
        }
      }else {
        return 0;
      }
      
    },
    proceed: function () {
      this.$router.push({ name: 'passengers' })
    },
    showExtraDescription(title,desc) {
      this.selectedExtraTitle = title
      this.selectedExtraDescription = desc
      this.showDescModal = true
    },
    hideExtraModal(){
      this.showDescModal = false
    }
  },
  created () {
    this.$root.booking.extras = []
  },
  mounted () {
    if(!this.$root.instance) {
      this.$router.push({ name: 'tour' })
    }
    this.getExtras()
  }
}
</script>